"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isDate_1 = __importDefault(require("./isDate"));
var isString_1 = __importDefault(require("./isString"));
var toLocalTime_1 = __importDefault(require("./toLocalTime"));
var toDate = function (obj) {
    Object.keys(obj).forEach(function (prop) {
        if ((0, isString_1.default)(obj[prop]) && (0, isDate_1.default)(obj[prop])) {
            obj[prop] = (0, toLocalTime_1.default)(obj[prop]);
        }
        if (typeof obj[prop] === 'object' && obj[prop]) {
            if (obj[prop] instanceof Array) {
                obj[prop].forEach(toDate);
            }
            else {
                Object.keys(obj[prop]).forEach(function () { return toDate(obj[prop]); });
            }
        }
    });
};
exports.default = toDate;
